import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  InputNumber,
  Switch,
  Upload,
  message,
  Card,
  Row,
  Col,
  Spin,
  Divider,
  Table,
  Modal,
} from "antd";
import {
  UploadOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import api from "../../../api";
import TinyEditor from "../../../components/Editor";
import { SEO_CONFIG } from "../../../seo-congig";

const { TextArea } = Input;

function AddProduct() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fetchingData, setFetchingData] = useState(true);
  const [categories, setCategories] = useState([]);
  const [guarantees, setGuarantees] = useState([]);
  const [countries, setCountries] = useState([]);
  const [brands, setBrands] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [cars, setCars] = useState([]);
  const [carType, setCarType] = useState([]);
  const [selectedCarTypes, setSelectedCarTypes] = useState([]);

  const [attributes, setAttributes] = useState([]);
  const [imageFiles, setImageFiles] = useState([]);
  const [editorContent1, setEditorContent1] = useState("");
  const [editorContent2, setEditorContent2] = useState("");
  const [editorContent3, setEditorContent3] = useState("");
  const [editorContent4, setEditorContent4] = useState("");
  const [uploading, setUploading] = useState(false);
  const [gallery, setGallery] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [brandFields, setBrandFields] = useState([
    {
      id: "",
      price: "",
      offPrice: "",
      seller_id: "",
      guarantee_id: "",
      country_id: "",
      count: "",
      seller_order: "",
    },
  ]);

  const [carFields, setCarFields] = useState([{ car_id: "", car_type_id: "" }]);

  const handleEditorChange1 = (content) => {
    setEditorContent1(content);
  };

  const GalleryModal = ({
    visible,
    onCancel,
    onSave,
    gallery,
    onDeleteImage,
  }) => {
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);

    const handleUpload = async () => {
      try {
        setUploadingImage(true);
        const values = await form.validateFields();
        const formData = new FormData();

        // اضافه کردن فایل به FormData
        if (fileList.length > 0) {
          formData.append("image", fileList[0].originFileObj || fileList[0]);
        }

        formData.append("alt", values.alt);
        formData.append("order", values.order);

        const response = await api.post(
          "/panel/gallery/upload-product-img",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        onSave(response.data); // ذخیره اطلاعات تصویر در لیست گالری
        message.success("تصویر با موفقیت آپلود شد");
        form.resetFields();
        setFileList([]);
      } catch (error) {
        message.error("آپلود تصویر با خطا مواجه شد");
        console.error("خطا در آپلود تصویر:", error);
      } finally {
        setUploadingImage(false);
      }
    };

    const uploadProps = {
      beforeUpload: (file) => {
        const isImage = file.type.startsWith("image/");
        if (!isImage) {
          message.error(`${file.name} فایل تصویر نیست`);
          return Upload.LIST_IGNORE;
        }
        setFileList([file]);
        return false;
      },
      onRemove: () => {
        setFileList([]);
      },
      fileList,
    };

    return (
      <Modal
        visible={visible}
        onCancel={onCancel}
        title="افزودن تصویر به گالری"
        footer={[
          <Button key="back" onClick={onCancel}>
            لغو
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={uploadingImage}
            onClick={handleUpload}
          >
            آپلود
          </Button>,
        ]}
        width={800} // تنظیم عرض Modal
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="alt"
            label="Alt"
            rules={[{ required: true, message: "لطفاً alt را وارد کنید" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="order"
            label="Order"
            rules={[{ required: true, message: "لطفاً order را وارد کنید" }]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item label="تصویر">
            <Upload {...uploadProps}>
              <Button icon={<UploadOutlined />}>انتخاب تصویر</Button>
            </Upload>
          </Form.Item>
        </Form>

        <Divider />

        <Table
          columns={columns}
          dataSource={gallery}
          rowKey="id"
          pagination={false}
          scroll={{ y: 300 }} // تنظیم ارتفاع جدول
        />
      </Modal>
    );
  };

  const handleDeleteImage = (id) => {
    const updatedGallery = gallery.filter((image) => image.id !== id);
    setGallery(updatedGallery);
  };

  const columns = [
    {
      title: "نام فایل",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Alt",
      dataIndex: "alt",
      key: "alt",
    },
    {
      title: "Order",
      dataIndex: "order",
      key: "order",
    },
    {
      title: "سایز",
      dataIndex: "size",
      key: "size",
    },
    {
      title: "تصویر",
      dataIndex: "url",
      key: "url",
      render: (url) => <img src={url} alt="تصویر" width={50} />,
    },
    {
      title: "عملیات",
      key: "actions",
      render: (_, record) => (
        <Button
          danger
          icon={<DeleteOutlined />}
          onClick={() => handleDeleteImage(record.id)}
        >
          حذف
        </Button>
      ),
    },
  ];

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    setFetchingData(true);
    try {
      const [
        categoriesRes,
        brandsRes,
        carRes,
        carTypeRes,
        sellerRes,
        countryRes,
        guaranteeRes,
      ] = await Promise.all([
        api.get(`/panel/category?per_page=15`),
        api.get(`/panel/brand?type=part&per_page=15`),
        api.get(`/panel/car?per_page=15`),
        api.get(`/panel/car-type?per_page=15`),
        api.get(`/panel/seller?per_page=15`),
        api.get(`/panel/country?per_page=15`),
        api.get(`/panel/guarantee?per_page=15`),
      ]);

      setCategories(categoriesRes?.data.data || []);
      setBrands(brandsRes?.data?.data || []);
      setCars(carRes.data?.data || []);
      setCarType(carTypeRes?.data?.data || []);
      setSellers(sellerRes?.data?.data || []);
      setCountries(countryRes?.data?.data || []);
      setGuarantees(guaranteeRes?.data?.data || []);
    } catch (error) {
      message.error("دریافت اطلاعات اولیه با خطا مواجه شد");
      console.error("خطا در دریافت اطلاعات:", error);
    } finally {
      setFetchingData(false);
    }
  };

  const handleSearch = async (searchTerm, endpoint, setState) => {
    try {
      const response = await api.get(`/panel/${endpoint}?search=${searchTerm}`);
      setState(response?.data?.data || []);
    } catch (error) {
      console.error("خطا در جستجو:", error);
    }
  };

  const uploadProps = {
    beforeUpload: (file) => {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        message.error(`${file.name} فایل تصویر نیست`);
        return Upload.LIST_IGNORE;
      }
      return false;
    },
    onChange: ({ fileList }) => {
      const validFiles = fileList.filter(
        (file) => !file.status || file.status !== "error"
      );
      setImageFiles(validFiles);
    },
    onRemove: (file) => {
      const newFileList = imageFiles.filter((item) => item.uid !== file.uid);
      setImageFiles(newFileList);
    },
    multiple: true,
    listType: "picture",
    accept: "image/*",
    fileList: imageFiles,
  };

  const addBrandField = () => {
    setBrandFields([
      ...brandFields,
      { id: "", price: "", offPrice: "", count: "", seller_order: "" },
    ]);
  };

  const addCarField = () => {
    setCarFields([...carFields, { car_id: "", car_type_id: "" }]);
  };

  const removeCarField = (index) => {
    const newCarFields = [...carFields];
    newCarFields.splice(index, 1);
    setCarFields(newCarFields);
  };

  const handleCarFieldChange = (index, field, value) => {
    const newCarFields = [...carFields];
    newCarFields[index][field] = value;
    setCarFields(newCarFields);
  };

  const handleCarChange = async (carId, index) => {
    try {
      const response = await api.get(`/panel/car/${carId}`);
      const carTypes = response?.data?.data?.car_types || [];
      setSelectedCarTypes(carTypes);

      // به‌روزرسانی نوع خودروها در carFields
      const newCarFields = [...carFields];
      newCarFields[index].car_type_id = ""; // Reset car type when car changes
      setCarFields(newCarFields);
    } catch (error) {
      console.error("خطا در دریافت نوع خودروها:", error);
    }
  };

  const removeBrandField = (index) => {
    const newBrandFields = [...brandFields];
    newBrandFields.splice(index, 1);
    setBrandFields(newBrandFields);
  };

  const handleBrandFieldChange = (index, field, value) => {
    const newBrandFields = [...brandFields];
    newBrandFields[index][field] = value;
    setBrandFields(newBrandFields);
  };

  const onFinish = async (values) => {
    if (
      !brandFields ||
      brandFields.length === 0 ||
      !brandFields.some((field) => field.id)
    ) {
      message.error("حداقل یک برند باید انتخاب شود");
      return; // جلوگیری از ارسال فرم
    }
    setLoading(true);
    try {
      const formData = new FormData();

      const appendIfExists = (key, value) => {
        if (value !== undefined && value !== null && value !== "") {
          formData.append(key, value);
        }
      };

      const basicFields = [
        "title",
        "summery",
        "technical_code",
        "order",
        "slug",
        "description",
        "order",
      ];
      basicFields.forEach((field) => {
        if (values[field] !== undefined) {
          formData.append(field, values[field]);
        }
      });

      formData.append("status", values.status);

      if (values.categories && values.categories.length > 0) {
        values.categories.forEach((categoryId) =>
          formData.append("categories[]", categoryId)
        );
      }

      brandFields.forEach((field, index) => {
        formData.append(`brands[${index}][id]`, field.id);
        formData.append(`brands[${index}][price]`, field.price);
        formData.append(`brands[${index}][offPrice]`, field.offPrice);
        formData.append(`brands[${index}][seller_order]`, field.seller_order);
        formData.append(`brands[${index}][seller_id]`, field.seller_id || "");
        formData.append(`brands[${index}][count]`, field.count);
        formData.append(
          `brands[${index}][guarantee_id]`,
          field.guarantee_id ? field.guarantee_id : ""
        );
        formData.append(
          `brands[${index}][country_id]`,
          field.country_id ? field.country_id : ""
        );
      });

      // Process car fields if available and valid
      if (Array.isArray(carFields) && carFields.length > 0) {
        carFields.forEach((field, index) => {
          if (field?.car_id || field?.car_type_id) {
            // بررسی مقدار معتبر قبل از افزودن به فرم
            appendIfExists(`cars[${index}][car_id]`, field.car_id);
            appendIfExists(`cars[${index}][car_type_id]`, field.car_type_id);
          }
        });
      }

      formData.append("body", editorContent1);

      appendIfExists("seo_title", values.seo_title);
      appendIfExists("seo_description", values.seo_description);
      appendIfExists("canonical", values.canonical);
      formData.append("follow", values.follow ? "1" : "0");
      formData.append("index", values.index ? "1" : "0");

      formData.append("returned", values.returned ? 1 : 0);
      formData.append("original", values.original ? 1 : 0);
      formData.append("used", values.used ? 1 : 0);
      formData.append("need_shasi", values.need_shasi ? 1 : 0);
      formData.append("showcase", values.showcase ? 1 : 0);
      formData.append("suggest", values.suggest ? 1 : 0);

      gallery.forEach((image) => {
        formData.append("gallery_ids[]", image.id);
      });

      await api.post(`/panel/product`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      message.success("محصول با موفقیت اضافه شد");
      navigate("/products");
    } catch (error) {
      if (error.response) {
        // بک‌اند پاسخ داده ولی با خطا
        const { data } = error.response;

        if (data.errors) {
          // اگر خطاها به‌صورت آرایه‌ای باشند
          Object.values(data.errors).forEach((errorMessages) => {
            errorMessages.forEach((msg) => message.error(msg));
          });
        } else if (data.message) {
          // اگر فقط یک پیام خطا وجود داشته باشد
          message.error(data.message);
        } else {
          message.error("خطایی از سمت سرور دریافت شد");
        }
      } else if (error.request) {
        // درخواست ارسال شده ولی پاسخی دریافت نشده است
        message.error(
          "پاسخی از سرور دریافت نشد، لطفاً اتصال خود را بررسی کنید"
        );
      } else {
        // سایر خطاها
        message.error("مشکلی در پردازش درخواست پیش آمد");
      }

      console.error("خطا در افزودن محصول:", error);
    } finally {
      setLoading(false);
    }
  };


  if (fetchingData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin size="large" tip="در حال بارگذاری..." />
      </div>
    );
  }

  return (
    <div>
      <Card title="افزودن محصول جدید" className="mb-4">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={() => {
            message.error("لطفاً فیلدهای ضروری را پر کنید.");
          }}
          initialValues={{ active: true }}
          scrollToFirstError
        >
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                name="title"
                label="عنوان"
                rules={[
                  { required: true, message: "لطفاً عنوان را وارد کنید" },
                ]}
              >
                <Input style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item
                name="slug"
                label="پیوند(لینک این محصول در وبسایت)"
                rules={[
                  { required: true, message: "لطفاً پیوند را وارد کنید" },
                ]}
              >
                <Input style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="technical_code"
                label="کد فنی"
                rules={[
                  { required: true, message: "لطفاً کد فنی را وارد کنید" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="order" label="ترتیب">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="status"
                label="وضعیت"
                rules={[
                  {
                    required: true,
                    message: "لطفاً  وضعیت را انتخاب کنید.",
                  },
                ]}
              >
                <Select placeholder="نوع  وضعیت را انتخاب کنید">
                  <Select.Option value="0">پیش نویس</Select.Option>
                  <Select.Option value="1">منتشر شده</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="categories"
                label="دسته‌بندی‌ها"
                rules={[
                  {
                    required: true,
                    message: "لطفاً حداقل یک دسته‌بندی را انتخاب کنید",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  placeholder="دسته‌بندی‌ها را انتخاب کنید"
                  style={{ width: "100%" }}
                  allowClear
                  onSearch={(value) =>
                    handleSearch(value, "category", setCategories)
                  }
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={categories.map((category) => ({
                    value: category.id,
                    label: category.name,
                  }))}
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="description"
            label="توضیحات کوتاه"
            // rules={[{ required: true, message: "لطفاً توضیحات را وارد کنید" }]}
          >
            <TextArea rows={4} />
          </Form.Item>

          <Card>
            <div style={{ marginBottom: 16 }}>
              <strong>تامین کننده‌ها</strong>
            </div>
            {brandFields.map((field, index) => (
              <Row
                gutter={16}
                key={index}
                style={{ marginBottom: 16 }}
                align="middle"
              >
                {/* برند */}
                <Col flex="1 1 200px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    برند قطعه
                  </div>
                  <Select
                    placeholder="انتخاب برند قطعه"
                    value={field.id}
                    onChange={(value) =>
                      handleBrandFieldChange(index, "id", value)
                    }
                    onSearch={(value) =>
                      handleSearch(value, "brand", setBrands)
                    }
                    options={brands.map((brand) => ({
                      value: brand.id,
                      label: brand.name,
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: "100%" }} // عرض کامل
                  />
                </Col>

                {/* فروشنده */}
                <Col flex="1 1 200px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    تامین کننده قطعه
                  </div>
                  <Select
                    placeholder="انتخاب تامین کننده قطعه"
                    value={field.seller_id}
                    onChange={(value) =>
                      handleBrandFieldChange(index, "seller_id", value)
                    }
                    onSearch={(value) =>
                      handleSearch(value, "seller", setSellers)
                    }
                    options={sellers.map((seller) => ({
                      value: seller.id,
                      label: seller.name,
                    }))}
                    showSearch
                    filterOption={false} // Disable local filtering
                    style={{ width: "100%" }}
                  />
                </Col>

                {/* گارانتی */}
                <Col flex="1 1 200px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    گارانتی قطعه
                  </div>
                  <Select
                    placeholder="انتخاب گارانتی قطعه"
                    value={field.guarantee_id}
                    onChange={(value) =>
                      handleBrandFieldChange(index, "guarantee_id", value)
                    }
                    options={guarantees.map((guarantee) => ({
                      value: guarantee.id,
                      label: guarantee.name,
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: "100%" }} // عرض کامل
                  />
                </Col>

                {/* تعداد */}
                <Col flex="1 1 100px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    تعداد
                  </div>
                  <InputNumber
                    placeholder="تعداد"
                    value={field.count}
                    onChange={(value) =>
                      handleBrandFieldChange(index, "count", value)
                    }
                    style={{ width: "100%" }}
                  />
                </Col>

                {/* قیمت */}
                <Col flex="1 1 150px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    قیمت
                  </div>
                  <InputNumber
                    placeholder="قیمت"
                    value={field.price}
                    onChange={(value) =>
                      handleBrandFieldChange(index, "price", value)
                    }
                    style={{ width: "100%" }} // عرض کامل
                  />
                </Col>

                {/* قیمت تخفیف */}
                <Col flex="1 1 100px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    قیمت تخفیف
                  </div>
                  <InputNumber
                    placeholder="قیمت تخفیف"
                    value={field.offPrice}
                    onChange={(value) =>
                      handleBrandFieldChange(index, "offPrice", value)
                    }
                    style={{ width: "100%" }} // عرض کامل
                  />
                </Col>
                <Col flex="1 1 100px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    اولویت نمایش
                  </div>
                  <InputNumber
                    placeholder=" اولویت نمایش"
                    value={field.seller_order}
                    onChange={(value) =>
                      handleBrandFieldChange(index, "seller_order", value)
                    }
                    style={{ width: "100%" }} // عرض کامل
                  />
                </Col>

                {/* دکمه حذف */}
                <Col flex="0 0 50px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    حذف
                  </div>
                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => removeBrandField(index)}
                    disabled={brandFields.length === 1}
                    style={{ width: "100%" }}
                  />
                </Col>
              </Row>
            ))}
            <Button
              type="dashed"
              onClick={addBrandField}
              icon={<PlusOutlined />}
            >
              افزودن تامین کننده
            </Button>
          </Card>

          <Card className="mt-4">
            <div style={{ marginBottom: 16 }}>
              <strong>خودروها</strong>
            </div>
            {carFields.map((field, index) => (
              <Row
                gutter={16}
                key={index}
                style={{ marginBottom: 16 }}
                align="middle"
              >
                <Col flex="1 1 300px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    خودرو
                  </div>
                  <Select
                    placeholder="انتخاب خودرو"
                    value={field.car_id}
                    onChange={(value) => {
                      handleCarFieldChange(index, "car_id", value);
                      handleCarChange(value, index);
                    }}
                    onSearch={(value) => handleSearch(value, "car", setCars)}
                    options={cars.map((car) => ({
                      value: car.id,
                      label: car.name,
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: "100%" }} // عرض کامل
                  />
                </Col>

                <Col flex="1 1 300px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    نوع خودرو
                  </div>
                  <Select
                    placeholder="انتخاب نوع خودرو"
                    value={field.car_type_id}
                    onChange={(value) =>
                      handleCarFieldChange(index, "car_type_id", value)
                    }
                    options={selectedCarTypes.map((type) => ({
                      value: type.id,
                      label: type.name,
                    }))}
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: "100%" }} // عرض کامل
                  />
                </Col>

                {/* دکمه حذف */}
                <Col flex="0 0 50px">
                  <div
                    style={{ marginBottom: 4, fontSize: "12px", color: "#666" }}
                  >
                    حذف
                  </div>
                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => removeCarField(index)}
                    disabled={carFields.length === 1}
                    style={{ width: "100%" }} // عرض کامل
                  />
                </Col>
              </Row>
            ))}
            <Button type="dashed" onClick={addCarField} icon={<PlusOutlined />}>
              افزودن خودرو
            </Button>
          </Card>

          <Form.Item
            label=" محتوا"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                validator: (_, value) => {
                  if (!editorContent1) {
                    return Promise.reject("لطفاً   محتوا را وارد کنید.");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <TinyEditor
              content={editorContent1}
              onEditorChange={handleEditorChange1}
              model={"Product"}
              height={300}
            />
          </Form.Item>

          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name="original" label="اصل" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="used" label="کارکرده" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="returned" label="مرجوعی" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="need_shasi"
                label="نیاز به وارد کردن شاسی"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="showcase"
                label="در ویترین آرشیو"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="suggest"
                label=" پیشنهادی"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item label="گالری تصاویر">
            <Button type="primary" onClick={() => setModalVisible(true)}>
              افزودن تصویر به گالری
            </Button>
          </Form.Item>

          <GalleryModal
            visible={modalVisible}
            onCancel={() => setModalVisible(false)}
            onSave={(image) => setGallery([...gallery, image])}
            onDeleteImage={(id) => handleDeleteImage(id)}
            gallery={gallery}
          />

          <Divider>بخش سئو</Divider>
          <Form.Item
            name="seo_title"
            label="عنوان سئو"
            help={SEO_CONFIG.title.helpText}
          >
            <Input maxLength={SEO_CONFIG.title.maxLength} showCount />
          </Form.Item>

          <Form.Item
            name="seo_description"
            label="توضیحات سئو"
            help={SEO_CONFIG.description.helpText}
          >
            <TextArea
              rows={4}
              maxLength={SEO_CONFIG.description.maxLength}
              showCount
            />
          </Form.Item>

          <Form.Item name="canonical" label="URL Canonical">
            <Input />
          </Form.Item>

          <Row gutter={24}>
            <Col span={12}>
              <Form.Item name="follow" label="Follow" valuePropName="checked">
                <Switch defaultChecked="true" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="index" label="Index" valuePropName="checked">
                <Switch defaultChecked="true" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              افزودن محصول
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default AddProduct;
